import React from "react";
import {
    getFieldTypeLabel,
    hideModal,
    showModalNoOutsideClick,
    getBoolSelectYN
} from "../../util/FormatUtil";
import { CustomFieldsModal } from "./CustomFieldsModal";
import InBetweenOverlay from "../InBetweenOverlay";
import Overlay from "../Overlay";
import CustomFieldsAPI from "../../network/CustomFieldsAPI";
import { sweetalert } from "../../App";
import {BiMoveVertical} from "react-icons/bi";

interface QuestionnaireState{
    selectedQuestionnaire?
    customFieldData?
    showInBetween
    questions
    showLoading
    showSaveOrderButton
    mouseGrabbing
}
interface QuestionnaireProps{
    selectedQuestionnaire?
    pageCustomQuestions?
    handleInBetween?
    selectedServiceQuestions?
    validPages?
    fieldTypes?
    selectedService?
}
export class QuestionnaireModal extends React.Component<QuestionnaireProps, QuestionnaireState>{
    public dragItemRef;
    public dragOverItemRef;
    public static ID = "questionnaire";
    
    constructor(props) {
        super(props);
        
        this.state = {
          showSaveOrderButton: false,
          showLoading: false,
          showInBetween: false,
          questions: [],
          mouseGrabbing: false
        }

        this.dragItemRef = React.createRef();
        this.dragOverItemRef = React.createRef();
    }

    componentWillReceiveProps(nextProps:any, nextContext: any) {
        this.setState({questions: nextProps.selectedServiceQuestions ? nextProps.selectedServiceQuestions : []})
    }

    handleSort = () => {
      //duplicate items
      let _questions = [...this.state.questions];

      //remove and save the dragged item content
      const draggedItemContent = _questions.splice(this.dragItemRef.current, 1)[0]

      //switch the position
      _questions.splice(this.dragOverItemRef.current, 0, draggedItemContent)

      //reset the position ref         
      this.dragItemRef.current = null
      this.dragOverItemRef.current = null

      //map through questions to get new order
      _questions.map((q, index) => {
          q.Order = index + 1
      })

      //update the state
      this.setState({questions: _questions, showSaveOrderButton: true})
    }

    saveOrder = () => {
      this.setState({showLoading: true}, async() => {
        let response = await CustomFieldsAPI.updateSortOrder(this.state.questions)
        if(!response.success){
          let msg = `Unable to update sort order at this time.`;
          if(response.reason){
            msg = response.reason;
          }
          this.setState({showLoading: false})
          return sweetalert.fire({icon: 'error', title: "", text: msg});
        }
        sweetalert.fire({icon: "success", title: "", text: `Sort order saved`})
          .then(() => {
            this.setState({showLoading: false, showSaveOrderButton: false})
            this.props.handleInBetween()
            hideModal(QuestionnaireModal.ID)
          })
      })
    }
   
    render(){
        // console.log('Q modal props', this.props)
        // console.log('Q modal state', this.state)
        return(
            <>
            <Overlay show_loading={this.state.showLoading} zIndex={100005}/>
            <InBetweenOverlay showInBetween={this.state.showInBetween} zIndex={100004} />
            <CustomFieldsModal
                    fieldTypes={this.props.fieldTypes}
                    validPages={this.props.validPages}
                    customQuestions={this.state.questions}
                    selectedCustomField={this.state.selectedQuestionnaire}
                    selectedService={this.props.selectedService}
                    isQuestionnaire={true}
                    handleInBetweenOnQuestionnaire={() => this.setState({showInBetween: false})}
                    onSubmitQuestionnaire={() => {
                        this.setState({showInBetween: false});
                        hideModal(CustomFieldsModal.ID);
                        hideModal(QuestionnaireModal.ID);
                        this.props.handleInBetween()
                    }}
                />
            <div className="modal fade form_modal " id={QuestionnaireModal.ID} tabIndex={-1} style={{zIndex: 100003}} role="dialog"
                 aria-labelledby="result_modal_label"
                 aria-hidden="true">
                <div className="modal-dialog modal-lg modal-xl" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                              <h5 className="modal-title" id="result_modal_label">Questionnaire Management {this.props.selectedService ? `for ${this.props.selectedService.Name}` : ''}</h5>
                              <button  style={{outline: 'none'}} type="button" className="close" data-dismiss="modal" aria-label="Close" 
                              onClick={() => {
                                this.setState({showSaveOrderButton: false})
                                this.props.handleInBetween()
                              }}>
                                  <span aria-hidden="true">&times;</span>
                              </button>                                                             
                        </div>
                        <div className="modal-body m-3 ">

                          {/* mobile  */}
                          {this.state.questions.length > 0 ?
                          <div className="d-md-none">
                        <table className="table">
                          <thead>
                            <tr>
                              {/* <th scope='col' style={{width: '10%'}}>Sort</th> */}
                              <th scope='col' style={{width: '18%'}}>Display Name</th>
                              <th scope='col' style={{width: '18%'}}>Field Type</th>                              
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.questions.length > 0 && this.state.questions.map((question, index) => {
                              return (
                              // <tr 
                              //   key={index} 
                              //   draggable 
                              //   onDragStart={(e) => this.dragItemRef.current = index}
                              //   onDragEnter={(e) => this.dragOverItemRef.current = index}
                              //   onDragEnd={this.handleSort}
                              //   onDragOver={(e) => e.preventDefault()}
                              // >
                              //   <td scope='row'><BiMoveVertical /></td>
                              //   <td scope='row'>
                              //     <a href='#' onClick={() => {
                              //         if(this.state.showSaveOrderButton){
                              //           return sweetalert.fire({icon: 'warning', title: '', text: 'Please save sort order'})
                              //         } 
                              //         else{
                              //           this.setState({showInBetween: true, selectedQuestionnaire: question },
                              //             () => showModalNoOutsideClick(CustomFieldsModal.ID))
                              //         }
                              //     }}>
                              //       {question.DisplayName}
                              //     </a>
                              //   </td>
                              <tr>
                                <td scope='row'>{question.DisplayName}</td>
                                <td scope='row'>{getFieldTypeLabel(question.FieldTypeID)}</td>
                              </tr>
                            )})}
                            
                          </tbody>
                        </table>
                        </div>
                        : 
                        <div className="d-md-none text-center text-bold" style={{fontSize: '1.5rem'}}>No questions to display</div>

                        }


                         {/* tablet  */}
                         {this.state.questions.length > 0 ?
                          <div className="d-none d-md-block d-lg-none">
                        <table className="table">
                          <thead>
                            <tr>
                              {/* <th scope='col' style={{width: '10%'}}>Sort</th> */}
                              <th scope='col' style={{width: '18%'}}>Display Name</th>
                              <th scope='col' style={{width: '18%'}}>Field Type</th>   
                              <th scope='col' style={{width: '18%'}}>Active</th>
                              <th scope='col' style={{width: '18%'}}>Required?</th>                           
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.questions.length > 0 && this.state.questions.map((question, index) => {
                              return (
                              // <tr 
                              //   key={index} 
                              //   draggable 
                              //   onDragStart={(e) => this.dragItemRef.current = index}
                              //   onDragEnter={(e) => this.dragOverItemRef.current = index}
                              //   onDragEnd={this.handleSort}
                              //   onDragOver={(e) => e.preventDefault()}
                              // >
                              //   <td scope='row'><BiMoveVertical /></td>
                              //   <td scope='row'>
                              //     <a href='#' onClick={() => {
                              //         if(this.state.showSaveOrderButton){
                              //           return sweetalert.fire({icon: 'warning', title: '', text: 'Please save sort order'})
                              //         } 
                              //         else{
                              //           this.setState({showInBetween: true, selectedQuestionnaire: question },
                              //             () => showModalNoOutsideClick(CustomFieldsModal.ID))
                              //         }
                              //     }}>
                              //       {question.DisplayName}
                              //     </a>
                              //   </td>
                              <tr>
                                <td scope='row'>{question.DisplayName}</td>
                                <td scope='row'>{getFieldTypeLabel(question.FieldTypeID)}</td>
                                <td scope='row'>{getBoolSelectYN(question.Options.isActive)}</td>
                                <td scope='row'>{getBoolSelectYN(question.Options.isRequired)}</td>
                              </tr>
                            )})}
                            
                          </tbody>
                        </table>
                        </div>
                        : 
                        <div className="d-none d-md-block d-lg-none text-center text-bold" style={{fontSize: '1.5rem'}}>No questions to display</div>

                        }



                          {/* desktop  */}

                        {this.state.questions.length > 0 ?
                        <div className="d-none d-lg-block">
                        <table className="table">
                          <thead>
                            <tr>
                              <th scope='col' style={{width: '10%'}}>Sort</th>
                              <th scope='col' style={{width: '18%'}}>Display Name</th>
                              <th scope='col' style={{width: '18%'}}>Field Type</th>
                              <th scope='col' style={{width: '18%'}}>Required?</th>
                              <th scope='col' style={{width: '18%'}}>PHI?</th>
                              <th scope='col' style={{width: '18%'}}>Active</th>
                              
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.questions.length > 0 && this.state.questions.map((question, index) => {
                              return (
                              <tr 
                                key={index} 
                                draggable 
                                onDragStart={(e) => this.dragItemRef.current = index}
                                onDragEnter={(e) => this.dragOverItemRef.current = index}
                                onDragEnd={this.handleSort}
                                onDragOver={(e) => e.preventDefault()}
                              >
                                <td scope='row'><BiMoveVertical /></td>
                                <td style={{maxWidth: '200px'}} scope='row'>
                                  <a href='#' style={{display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}} title={question.DisplayName} onClick={() => {
                                      if(this.state.showSaveOrderButton){
                                        return sweetalert.fire({icon: 'warning', title: '', text: 'Please save sort order'})
                                      } 
                                      else{
                                        this.setState({showInBetween: true, selectedQuestionnaire: question },
                                          () => showModalNoOutsideClick(CustomFieldsModal.ID))
                                      }
                                  }}>
                                    {question.DisplayName}
                                  </a>
                                </td>
                                <td scope='row'>{getFieldTypeLabel(question.FieldTypeID)}</td>
                                <td scope='row'>{getBoolSelectYN(question.Options.isRequired)}</td>
                                <td scope='row'>{getBoolSelectYN(question.Options.isPHI)}</td>
                                <td scope='row'>{getBoolSelectYN(question.Options.isActive)}</td>
                              </tr>
                            )})}
                            
                          </tbody>
                        </table>
                        </div>
                        : 
                        <div className="d-none d-lg-block text-center text-bold" style={{fontSize: '1.5rem'}}>No questions to display</div>
                        }

                        </div>
                        <div className="modal-footer">
                        <button type="button" className={this.state.showSaveOrderButton ? "d-none" : "btn btn-success mr-auto"} 
                          onClick={() => {
                            if(this.state.showSaveOrderButton){
                              return sweetalert.fire({icon: 'warning', title: '', text: 'Please save sort order'})
                            } 
                            else{
                              this.setState({showInBetween: true, selectedQuestionnaire: null})
                              showModalNoOutsideClick(CustomFieldsModal.ID)
                            }
                          }}
                          >Add Question
                          </button>
                          <button type="button" className={this.state.showSaveOrderButton ? "btn btn-primary" : "invisible" } onClick={this.saveOrder}>
                                Save Order
                          </button>
                        </div>
                    </div>
                </div>
            </div>
            </>
        )
    }
}